import { IS_MOBILE_APP_QUERY } from '@gig/magic-messages';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import {
    MobileAppMessageTypes,
    MobileAppNativeRoutes,
} from '@gig/magic-frontend-toolkit';

export async function initMobileAppRoutingGuard(router: VueRouter) {
    const isMobileApp: boolean =
        (await window.queryBus.query<boolean>(IS_MOBILE_APP_QUERY)) ?? false;

    const mobileRouteMap: Record<string, string> = {
        [RouteName.SIGN_UP]: MobileAppNativeRoutes.SIGN_UP_SCREEN,
        [RouteName.GAMES]: MobileAppNativeRoutes.LOBBY_SCREEN,
        [RouteName.HOME]: MobileAppNativeRoutes.LOBBY_SCREEN,
        [RouteName.LIVE_CASINO]: MobileAppNativeRoutes.LOBBY_SCREEN,
    };

    router.beforeResolve((to, from, next) => {
        if (isMobileApp) {
            const nativeRoute = mobileRouteMap[to.name as string];
            if (nativeRoute) {
                window.eventBus.publish(
                    MobileAppMessageTypes.NAVIGATE_TO_FROM_WEBVIEW,
                    { route: nativeRoute }, 
                );

                return next(from.name ? false : '/');
            }
        }

        next();
    });
}
